<template>
  <div>
    <div class="border">
      <list
        @input="change"
        :simple="true"
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :isUpdate="false"
        :isAdd="true"
        :itemLink="itemLink"
        :setLink="setLink"
        :openItem="false"
        :fields="fields"
        :params="params"
        title_add="Добавить карту"
        title_add_key="add_card"
        :searchDisable="true"
        @changeFunction="changeFunction"
        v-model="val"
      />

      <div v-if="card" class="mt-5">
        <p>Карта: {{ card.card_number }}</p>
        <p>Дата: {{ card.exp }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {
      if (val && val.length) {
        this.$emit("input", val[0].id);
        this.$emit("inputCard", val[0]);
      }
    },
  },
  props: ["id", "card"],
  created() {
    this.itemLink += `/${this.id}/cards`;
    this.setLink += `/${this.id}/cards`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "full_name",
          labelKey: "full_name",
          label: "Владелец карты (имя и фамилия)",
          type: "field",
        },
        {
          col: " col-12 col-md-12",
          key: "phone",
          labelKey: "card_phone",
          label: "Номер телефона привязанный в карте",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
        {
          col: " col-12 col-md-8",
          key: "card_number",
          labelKey: "card_number",
          label: "Номер карты",
          type: "mask",
          mask: "#### #### #### ####",
          placeholder: "#### #### #### ####",
        },
        {
          col: " col-12 col-md-4",
          key: "exp",
          labelKey: "card_exp",
          label: "Дата окончания",
          type: "mask",
          mask: "##/##",
          placeholder: "MM/ГГ",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_field",
      itemLink: "clients",
      setLink: "clients",
      columns: [
        {
          key: "card_number",
          titleKey: "card_number",
          title: "Номер карты",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          checkbox: true,
          detail: false,
          full: true,
        },
        {
          key: "phone",
          titleKey: "card_phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "exp",
          titleKey: "card_exp",
          title: "Дата",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "full_name",
          titleKey: "card_full_name",
          title: "Владелец карты",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
